// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"0a368761","977":"e67fe641"}[chunkId] + ".chunk.js";
};